import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { clearApplicationCache } from '../../utils/cacheUtils';

const UpdateDetector = () => {

  useEffect(() => {
    // Função para verificar se há uma nova versão
    const checkForUpdates = async () => {
      try {
        // Busca o manifest.json com cache busting
        const response = await fetch(`/manifest.json?t=${Date.now()}`, {
          cache: 'no-cache'
        });
        
        if (response.ok) {
          const manifest = await response.json();
          const currentVersion = localStorage.getItem('app_version');
          const newVersion = manifest.version || process.env.REACT_APP_VERSION || '0.1.2';
          
          // Se não há versão salva, salva a atual
          if (!currentVersion) {
            localStorage.setItem('app_version', newVersion);
            return;
          }
          
          // Se a versão mudou, força atualização imediata
          if (currentVersion !== newVersion) {
            localStorage.setItem('app_version', newVersion);
            forceImmediateUpdate();
          }
        }
      } catch (error) {
        console.log('Erro ao verificar atualizações:', error);
      }
    };

    // Verifica atualizações ao carregar
    checkForUpdates();

    // Verifica atualizações a cada 5 minutos
    const interval = setInterval(checkForUpdates, 5 * 60 * 1000);

    // Verifica quando a aba fica visível novamente
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkForUpdates();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const forceImmediateUpdate = () => {
    console.log('🔄 Nova versão detectada - Atualizando imediatamente...');
    
    // Limpa cache usando função utilitária
    clearApplicationCache('app-update');
    
    // Força reload completo imediatamente
    window.location.reload(true);
  };

  // Não renderiza nenhuma interface - atualização é silenciosa
  return null;
};

export default UpdateDetector;